module.exports = __webpack_public_path__ + "img/idcard3.888f2c76.png";